<template>
    <ul class="list shadow" >
        <li class="list-item source-code-pro-400" v-for="item,index in list" :key="index">
            > {{ item }}
        </li>
    </ul>
</template>

<script setup lang="ts">
import { ref } from 'vue';

    const props = defineProps<{
        listItems: string[]
    }>()
    const list = ref(props.listItems)
</script>

<style lang="css" scoped>
.list{
    font-size: 15px;
    background-color: #FBF9F5;
    border-radius: 1rem;
    padding: 1.5rem;
    padding-left: 3.5rem;
    width: 90%;
    height: auto;    list-style: none;
    justify-content: center;
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
}

@media (min-width: 576px) {
    .list{
        width: 20%;
        font-size: 13px;
        padding-left: 5rem;
    }
}
</style>